import { colors } from '../../../../../../../../../../../colorVars';
import { DownArrow } from '../../../../../../../../../../../components/atomic/atomicComponentLibrary/icons/downArrow/DownArrow';
import { UpArrow } from '../../../../../../../../../../../components/atomic/atomicComponentLibrary/icons/upArrow/UpArrow';
import { Body3 } from '../../../../../../../../../../../components/atomic/text/Text';
import { sequenceMap } from '../../../../../../../../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/candlePattern/candlePatternMap';
import { timeUnitMap } from '../../../../../../../../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';
import ApplyRounding from '../../../../../../../../../../../utils/math/ApplyRounding';

export function candlePatternBuilder(parsedStatusObj) {
  const pluginTemplate = parsedStatusObj.pluginTemplate ?? null;
  if (!pluginTemplate) return null;
  const triggeredSetupPattern = pluginTemplate.triggeredSetupPattern;
  if (!triggeredSetupPattern) return null;
  const sequenceArr = triggeredSetupPattern.split('-');
  const translatedArr = sequenceArr.map((sequence) => sequenceMap[sequence]);
  const sequenceString = translatedArr.join('-');

  return (
    <td>
      <div style={{ display: 'flex'}}>
        <Body3 fontWeight={500} color={colors.lightGrey}>
          {pluginTemplate.candleDuration + timeUnitMap[pluginTemplate.timeUnit]}{' '}
          Candle Pattern {sequenceString}

        </Body3>
        {parsedStatusObj.tradeDirection ? (
          parsedStatusObj.tradeDirection === 'LONG' ? (
            <UpArrow size={13} margin="0 5px 0 5px"/>
          ) : (
            <DownArrow size={13} margin="0 5px 0 5px" />
          )
        ) : null}
        <Body3 fontWeight={500} color={colors.lightGrey}>
          [$
          {ApplyRounding(parsedStatusObj.triggerPrice, 2)}]
        </Body3>
      </div>
    </td>
  );
}
/*  5m Candle Pattern triggered on 3-1-2u */
// const example = {
//   "triggerPrice": 71.705067194274,
//   "tradeDirection": "LONG",
//   "tacticName": "CANDLE_PATTERN",
//   "symbol": "AAPL",
//   "pluginTemplate": {
//       "triggeredSetupPattern": "OUTSIDE_CANDLE-INSIDE_CANDLE-BREAK_HIGH",
//       "candleDuration": 1,
//       "timeUnit": "MINUTES",
//       "candle": {
//           "high": 71.705067194274,
//           "low": 70.44047683360876,
//           "open": 70.44047683360876,
//           "close": 71.70248815651333,
//           "candleSymbol": "AAPL",
//           "candleStartTimeStamp": 1651670640000,
//           "duration": "1min"
//       }
//   }
// }
